<template>
  <div class="method-card">
    <button @click="handleClick" :class="['card-button', methodClass]" :disabled="disabled">
      <div class="card-content">
        <slot>
          <img v-if="icon" :src="icon" :alt="methodName" class="card-icon" />
          <span class="card-text">{{ buttonText }}</span>
        </slot>
      </div>
    </button>
    <button 
      v-if="showInfo"
      @click="handleInfoClick"
      class="info-button"
      :title="'More information about ' + buttonText"
      aria-label="More information"
    >
      ℹ
    </button>
  </div>
</template>

<script>
export default {
  name: 'DepositMethodButton',
  props: {
    methodName: {
      type: String,
      required: true
    },
    methodClass: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: null
    },
    buttonText: {
      type: String,
      default: ''
    },
    textStyle: {
      type: Object,
      default: () => ({})
    },
    showInfo: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click', 'info-click'],
  methods: {
    handleClick() {
      if (!this.disabled) {
        this.$emit('click', this.methodName);
      }
    },
    handleInfoClick(e) {
      e.stopPropagation();
      this.$emit('info-click', this.methodName);
    }
  }
};
</script>

<style scoped>
.method-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.card-button {
  width: 120px;
  height: 120px;
  border: none;
  border-radius: 16px;
  cursor: pointer;
  color: white;
  font-weight: 600;
  font-size: 13px;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 12px;
}

.card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 100%;
}

.card-button:hover:not(:disabled) {
  transform: translateY(-6px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2);
}

.card-button:active:not(:disabled) {
  transform: translateY(-2px);
}

.card-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.card-button .card-icon {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

.card-text {
  display: block;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
}

/* Color classes */
.airtel {
  background: linear-gradient(135deg, #d32f2f 0%, #b71c1c 100%);
}

.tnm {
  background: linear-gradient(135deg, #2e7d32 0%, #1b5e20 100%);
}

.paychangu {
  background: linear-gradient(135deg, #1565c0 0%, #0d47a1 100%);
}

.vodacom {
  background: linear-gradient(135deg, #d32f2f 0%, #b71c1c 100%);
}

.help {
  background: linear-gradient(135deg, #ff9900 0%, #e68900 100%);
  color: white;
}

.ecocash {
  background: linear-gradient(135deg, #42a5f5 0%, #1e88e5 50%, #1565c0 100%);
  border: 3px dashed rgba(255, 255, 255, 0.75) !important;
  color: white;
}

.nedbank {
  background: linear-gradient(135deg, #033B78 0%, #022254 100%);
}

.mywallet {
  background: linear-gradient(135deg, #38ba63 0%, #2d8e4e 100%);
}

.ottvoucher {
  background: linear-gradient(135deg, #7b1fa2 0%, #4a148c 100%);
}

.info-button {
  width: 32px;
  height: 32px;
  border: 2px solid rgba(0, 0, 0, 0.2);
  background: white;
  border-radius: 50%;
  cursor: pointer;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  color: #333;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.info-button:hover {
  background-color: #f0f0f0;
  border-color: #1a73e8;
  color: #1a73e8;
  transform: scale(1.15);
}

.info-button:active {
  transform: scale(0.95);
}
</style>
